import type { SxProps, Theme } from '@mui/material/styles';

/**
 * How a selected toggle chip is marked: an accent outline on a raised fill,
 * with the text kept at full contrast. A filled accent chip puts small text
 * on the accent colour, where it is hard to read.
 */
export const SELECTED_CHIP_SX: SxProps<Theme> = {
    borderColor: 'primary.main',
    bgcolor: 'action.selected',
    color: 'text.primary',
    fontWeight: 600,
};
